<template>
  <div>
    <v-toolbar
      flat
      class="elevation-1"
    >
      <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      <video-ayuda-menu
        :grupo="'facturacion_centro_emitidos'"
        v-if="tipo === 'emitidos'"
      ></video-ayuda-menu>

      <v-spacer></v-spacer>

      <v-btn
        v-if="puedo('alta') && tipo === 'emitidos'"
        class="white--text"
        round
        color="primary"
        @click="crear"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >add</v-icon>
        Nuevo
      </v-btn>
      <v-btn
        class="white--text"
        round
        color="secondary"
        @click="exportar()"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >cloud_download</v-icon>
        Exportar
      </v-btn>
      <v-btn
        flat
        icon
        small
        @click="mostrarFiltros()"
      >
        <v-icon class="primary--text">filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <filtros
      v-bind:filtros="filtros"
      v-bind:referencia="referenciaFiltros"
      v-bind:combos="combos"
      v-on:alFiltrar="alFiltrar"
    ></filtros>
    <v-data-table
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">
        <tr>
          <template v-if="tipo === 'recibidos'">
            <td class="text-xs-left pa1">{{ props.item.facturado_por | nombreCentro }}</td>
            <td class="text-xs-left pa1">{{ props.item.fecha | formatoFecha }}</td>
            <td class="text-xs-left pa1">{{ props.item | cabeceraComprobante }}</td>
            <td class="text-xs-left pa1">
              {{
                props.item.facturado_obra_social
                  ? props.item.facturado_obra_social.nombre
                  : $options.filters.nombreCentro(props.item.facturado_institucion)
              }}
            </td>
            <td class="text-xs-left pa1">{{ obraSocialPlanFacturable(props.item) }}</td>
            <td class="text-xs-left pa1">{{ props.item.estado_facturacion.nombre }}</td>
            <td class="text-xs-right pa1">
              {{ props.item.importe_facturado | currency }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="primary"
                    dark
                    v-on="on"
                  >info</v-icon>
                </template>
                <span>Prefacturado: {{ props.item.importe_prefacturado | currency }}</span>
              </v-tooltip>
            </td>
          </template>
          <template v-else>
            <td class="text-xs-left pa1">{{ props.item.institucion | nombreCentro }}</td>
            <td class="text-xs-left pa1">{{ props.item.fecha | formatoFecha }}</td>
            <td class="text-xs-left pa1">
              {{ props.item | cabeceraComprobanteAbreviado }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="primary"
                    dark
                    v-on="on"
                  >info</v-icon>
                </template>
                <span>{{ props.item | cabeceraComprobante }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left pa1">
              {{
                props.item.facturado_obra_social
                  ? props.item.facturado_obra_social.nombre
                  : $options.filters.nombreCentro(props.item.facturado_institucion)
              }}
            </td>
            <td class="text-xs-left pa1">{{ obraSocialPlanFacturable(props.item) }}</td>
            <td class="text-xs-left pa1">
              {{ props.item.periodo_mes + '/' + props.item.periodo_ano }}
            </td>
            <td class="text-xs-left pa1">
              {{ props.item.estado_facturacion | estadoFactura }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="primary"
                    dark
                    v-on="on"
                  >info</v-icon>
                </template>
                <span>{{ props.item.estado_facturacion.nombre }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right pa1">
              {{ props.item.importe_facturado | currency }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="primary"
                    dark
                    v-on="on"
                  >info</v-icon>
                </template>
                <span>Prefacturado: {{ props.item.importe_prefacturado | currency }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right pa1">
              {{ (props.item.importe_facturado - props.item.importe_pagado) | currency }}
            </td>
          </template>
          <td class="justify-end layout">
            <template v-if="tipo === 'recibidos'">
              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                v-if="puedoDescargarComprobante(props.item)"
                @click="accionEnItem(props.item, 'descargar')"
              >
                <v-icon small>cloud_download</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                :disabled="!(puedo('lectura') || puedo('modif'))"
                @click="ver(props.item)"
              >
                <v-icon small>remove_red_eye</v-icon>
              </v-btn>

              <template v-if="
                  props.item.tipo_comprobante.codigo === 'FCT' &&
                    props.item.facturado_obra_social &&
                    props.item.facturado_obra_social.codigo === '900'
                ">
                <botones-procesar-fp-pami
                  v-bind:item="props.item"
                  v-on:procesar="procesarFacturaPrestacionPami"
                ></botones-procesar-fp-pami>

                <v-btn
                  icon
                  flat
                  small
                  color="blue-grey"
                  class="mx-1"
                  @click="accionEnItem(props.item, 'verDetalle')"
                >
                  <v-icon small>list</v-icon>
                </v-btn>
              </template>

              <v-menu
                bottom
                left
                fixed
                v-if="armarMenuAcciones(props.item).length > 0"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    small
                    color="blue-grey"
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile
                    v-for="(accion, key) in armarMenuAcciones(props.item)"
                    :key="key"
                    @click="accionEnItem(props.item, accion.key)"
                  >
                    <v-list-tile-action style="min-width:30px;">
                      <v-icon small>{{ accion.icono }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>{{ accion.titulo }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import EventBus from '@/helpers/eventBus'
import filtros from './FacturacionCentroListadoFiltros'
import botonesProcesarFpPami from './FacturacionCentroListadoProcesoFPPami'
import abmListadoMixin from '@/mixins/abmListado'
import alertaMixin from '@/mixins/alerta'
import {
  nombreCentro,
  cabeceraComprobante,
  cabeceraComprobanteAbreviado,
  estadoFactura
} from '@/helpers/filtros'
import VideoAyudaMenu from '@/components/Video/VideoAyudaMenu'
import _ from 'lodash'

export default {
  name: 'FacturacionCentroListado',
  mixins: [abmListadoMixin, alertaMixin],
  components: {
    botonesProcesarFpPami,
    filtros,
    VideoAyudaMenu
  },
  filters: {
    nombreCentro,
    cabeceraComprobante,
    cabeceraComprobanteAbreviado,
    estadoFactura
  },
  props: {
    tipo: {
      type: String,
      required: true
    },
    combos: {
      type: Object,
      required: true
    }
  },
  computed: {
    referenciaFiltros () {
      return this.referencia + '_' + 'centro'
    },
    usuario () {
      return this.$store.getters.getUser
    },
    videosAyudaVisibles () {
      return this.$store.getters['videoAyuda/videosPorGrupo']('facturacion_centro_emitidos')
    }
  },
  data: () => ({
    titulo: 'Comprobantes',
    headers: [],
    paginacion: { descending: true, sortBy: 'fecha' },
    info: {
      comprobantesERP: ['FC', 'NC', 'ND', 'FAC', 'NDC', 'NCC']
    }
  }),
  mounted () {
    this.titulo = this.tipo === 'recibidos' ? 'Comprobantes Recibidos' : 'Comprobantes Emitidos'

    if (this.tipo === 'recibidos') {
      this.headers = [
        { text: 'Facturado Por', value: 'facturado_por_id', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: true },
        { text: 'Comprobante', value: 'tipo_comprobante_id', sortable: false },
        { text: 'Facturado A', value: 'id', sortable: false },
        { text: 'Obra social', value: 'facturado_a_obra_social_id', sortable: false },
        { text: 'Est. Fac.', value: 'estado_facturacion_id', sortable: false },
        { text: 'Importe', value: 'importe_facturado', sortable: false, align: 'right' },
        { text: 'Acciones', value: 'id', sortable: false, align: 'center' }
      ]
    } else {
      this.headers = [
        { text: 'Centro', value: 'institucion_id', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: true },
        { text: 'Comprobante', value: 'tipo_comprobante_id', sortable: false },
        { text: 'Facturado A', value: 'id', sortable: false },
        { text: 'Obra social', value: 'facturado_a_obra_social_id', sortable: false },
        { text: 'Mes/Año', value: 'periodo_mes', sortable: false },
        { text: 'Est. Fac.', value: 'estado_facturacion_id', sortable: false },
        { text: 'Importe', value: 'importe_facturado', sortable: false, align: 'right' },
        { text: 'Saldo a Cob.', value: 'importe_facturado', sortable: false, align: 'right' },
        { text: 'Acciones', value: 'id', sortable: false, align: 'center' }
      ]
    }
  },
  methods: {
    metodoFiltrar (filtros) {
      let vm = this
      filtros.tipo = vm.tipo
      filtros.por = 'centro'
      return vm.modeloApi.filtrar(filtros)
    },

    accionEnItem (item, accion) {
      switch (accion) {
        case 'borrar':
          this.eliminar(item)
          break
        case 'pendiente':
        case 'facturado':
          if (item.importe_prefacturado > 0) {
            this.cambiarEstado(item, accion)
          } else {
            this.mostrarNotificacion('Para realizar la operación el importe debe ser mayor a 0', 'error')
          }

          break
        case 'verDetalle':
        case 'verCambioPln':
        case 'verDetallePami':
        case 'recibos':
        case 'ordenesPago':
          this.$emit('accion', accion, item)
          break
        case 'descargar':
          if (this.tipo === 'recibidos') {
            this.modeloApi.descargarComprobanteVta(item.id)
          } else {
            this.modeloApi.descargarComprobanteVta(item.padre.id)
          }

          break
        case 'exportarDetalle':
          this.modeloApi.exportarPacientesLaboratorios(item.id)
          break
        case 'auditoria':
          EventBus.$emit(accion + ':mostrar', item)
          break
      }
    },
    armarMenuAcciones (item) {
      let acciones = []
      let facturaPrestacionPami =
        item.tipo_comprobante.codigo === 'FCT' &&
        item.facturado_obra_social &&
        item.criterios.obra_social.codigo === '900'

      if (facturaPrestacionPami) {
        acciones.push({ key: 'exportarDetalle', icono: 'cloud_download', titulo: 'Exportar Pacientes / Laboratorios' })
      }

      switch (item.estado_facturacion.codigo) {
        case 'abierto':
          if (this.puedo('modif') || this.puedo('pasar-a-pendiente')) {
            if (item.tipo_comprobante.codigo === 'FCT') {
              acciones.push({ key: 'pendiente', icono: 'close', titulo: 'Pasar a pendiente' })
            } else {
              acciones.push({ key: 'facturado', icono: 'close', titulo: 'Pasar a facturado' })
            }
          }
          if (this.puedo('baja')) {
            acciones.push({ key: 'borrar', icono: 'delete', titulo: 'Borrar' })
          }
          break
        case 'facturado':
          if (facturaPrestacionPami) {
            if (this.puedo('modif')) {
              acciones.push({
                key: 'verCambioPln',
                icono: 'edit',
                titulo: 'Cambiar P.V. / Letra / Nro'
              })
            }

            if (item.importe_facturado > 0) {
              acciones.push({
                key: 'verDetallePami',
                icono: 'list',
                titulo: 'Detalle devolución PAMI'
              })
            }
          }

          if (this.tipo === 'recibidos') {
            if (
              item.padre &&
              this.info.comprobantesERP.indexOf(item.padre.tipo_comprobante.codigo) > -1 &&
              (item.padre.cae_externo ||
                (item.padre.comprobante_centum &&
                  item.padre.comprobante_centum.estado &&
                  item.padre.comprobante_centum.estado.codigo === 'facturado'))
            ) {
              acciones.push({ key: 'descargar', icono: 'cloud_download', titulo: 'Descargar' })
            }
          }

          if (item.importe_pagado > 0) {
            acciones.push({
              key: 'ordenesPago',
              icono: 'remove_red_eye',
              titulo: 'Ver Órdenes de pago'
            })
          }
          break

        case 'pago_parcial':
        case 'cerrado':
          if (this.puedo('lectura') && facturaPrestacionPami) {
            if (item.importe_facturado > 0) {
              acciones.push({
                key: 'verDetallePami',
                icono: 'list',
                titulo: 'Detalle devolución PAMI'
              })
            }
          }
          if (this.tipo === 'recibidos') {
            if (
              item.padre &&
              this.info.comprobantesERP.indexOf(item.padre.tipo_comprobante.codigo) > -1 &&
              (item.padre.cae_externo ||
                (item.padre.comprobante_centum &&
                  item.padre.comprobante_centum.estado &&
                  item.padre.comprobante_centum.estado.codigo === 'facturado'))
            ) {
              acciones.push({ key: 'descargar', icono: 'cloud_download', titulo: 'Descargar' })
            }
          }
          if (item.importe_pagado > 0) {
            acciones.push({
              key: 'ordenesPago',
              icono: 'remove_red_eye',
              titulo: 'Ver Órdenes de pago'
            })
          }

          break
      }
      acciones.push({
        key: 'auditoria',
        icono: 'verified_user',
        titulo: 'Auditoría'
      })
      return acciones
    },
    cambiarEstado (item, codigoEstado) {
      let vm = this

      if (confirm('Desea cambiar el estado del comprobante a ' + codigoEstado + '?')) {
        vm.cargando = true
        vm.modeloApi
          .cambiarEstado(item.id, codigoEstado)
          .then(() => {
            vm.mostrarMensajeOk()
            vm.cargando = false
            vm.filtrar()
          })
          .catch(error => {
            this.$emit('mostrarError', error)
            vm.cargando = false
          })
      }
    },
    procesarFacturaPrestacionPami (item) {
      let vm = this
      if (confirm('Desea procesar el comprobante?')) {
        // vm.cargando = true
        item.estado_facturacion.codigo = 'en_proceso'
        vm.modeloApi
          .procesarFacturaPrestacionPami(item.id)
          .then(item => {
            vm.mostrarMensajeOk()
            item.estado_facturacion.codigo = 'abierto'
            vm.filtrar()
          })
          .catch(error => {
            this.$emit('mostrarError', error)
            item.estado_facturacion.codigo = 'error'
          })
      }
    },
    mostrarFiltros () {
      EventBus.$emit(this.referenciaFiltros + ':abrir')
    },
    alFiltrar (filtros) {
      this.filtros = filtros
      this.filtrar()
    },
    obraSocialPlanFacturable (item) {
      let salida = ''
      if (item.criterios) {
        if (item.criterios.obra_social) {
          salida = salida.concat(item.criterios.obra_social.nombre)
        }
        if (item.criterios.plan) {
          salida = salida.concat(' ').concat(item.criterios.plan.nombre)
        }
        if (item.criterios.facturable) {
          salida = salida.concat(' / ').concat(item.criterios.facturable.nombre)
        }
      } else {
        if (item.facturado_obra_social) {
          salida = salida.concat(item.facturado_obra_social.nombre)
        }
      }
      return salida
    },
    filtrosExportar () {
      let vm = this
      let filtros = _.assign(vm.filtros, {
        tipo: vm.tipo,
        por: 'centro',
        usuario_id: vm.usuario.id
      })
      return filtros
    },
    puedoDescargarComprobante (item) {
      return (
        this.tipo === 'recibidos' &&
        this.info.comprobantesERP.indexOf(item.tipo_comprobante.codigo) > -1 &&
        ['facturado', 'pago_parcial', 'cerrado'].indexOf(item.estado_facturacion.codigo) > -1 &&
        (item.cae_externo ||
          (item.comprobante_centum &&
            item.comprobante_centum.estado &&
            item.comprobante_centum.estado.codigo === 'facturado'))
      )
    }
  }
}
</script>

<style lang="scss" scoped>
table.v-table tbody th {
  padding: 0px !important;
}
.pa1 {
  vertical-align: top !important;
  padding-left: 24px !important;
  padding-right: 0px !important;
  padding-bottom: 5px !important;
  padding-top: 0px !important;
  font-size: 13px !important;
}
table.v-table tbody tr:nth-child(even) {
  background: #f1f2f1 !important;
}
</style>
